import { UserCompanyModel } from '../../models-software-security';

export interface SecurityUser {
  userProfile: UserProfile;
  userEnviroments: UserEnviroment[];
}

interface UserEnviroment {
  applicationId: string;
  applicationName: string;
  isActive?: boolean;
  applicationEnvironments: ApplicationEnvironment[];
}

interface ApplicationEnvironment {
  userApplicationEnvironmentId: string;
  applicationEnvironmentId: string;
  userId?: string | number;
  isActive: boolean;
  applicationName?: string;
  url: string;
  environmentTypeName: string;
}

export interface UserProfile {
  userId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  isActive: boolean;
  hrref: number;
  adUserName: string;
  cellPhone: string;
  smsLinked: boolean;
  proxyHRRef: number;
  notes?: string;
  proxyHRRefs: string;
  userRoles: UserRole[];
  isActiveForced?: boolean;
  isActiveForcedExpiration?: boolean;
  isSyncedFromViewpoint: boolean;
  isTestAccount?: boolean;
  jobTitle?: string;
  internalAuthEnabled?: boolean;
}

export interface NewUser {
  userId: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  email: string;
  isActive: boolean;
  hrref: number;
  adUserName: string;
  cellPhone: string;
  smsLinked: boolean;
  proxyHRRef: number;
  notes?: string;
  proxyHRRefs: string;
  userRoles: UserRole[];
  isActiveForced?: boolean;
  isActiveForcedExpiration?: boolean;
  isSyncedFromViewpoint: boolean;
  isTestAccount?: boolean;
  jobTitle?: string;
  internalAuthEnabled?: boolean;
  userCompanies?: UserCompanyModel[];
}

interface UserRole {
  userRoleId: string;
  userId: string;
  roleName: string;
  roleId: string;
  isActive: boolean;
}
